import { FC } from 'react';
import { SessionContainerProps } from '../config';
import { SurveyResultData } from './PresentSurveyResult';
import { observer } from 'mobx-react';
import { useStores } from '../../../hooks/useStores';


const _ContainSurveyResult: FC<SessionContainerProps<SurveyResultData>> = ({
  onNext,
  onFinish,
  children,
}) => {
  const {treeNav, language} = useStores();

  const feature = treeNav.content.feature;
  const featureId = feature?.feature;
  const survey = treeNav.content.survey;
  const surveyId = treeNav.content.survey?._id;
  const pathId = treeNav.content.path?._id;
  const sessionId = treeNav.content.session?._id;
  const fromSurvey = treeNav.content.treeDataType === 'SURVEY';

  const labels = language.translate.MOBILE?.SESSION;

  return children({
    onNext,
    onFinish,
    data: {
      feature,
      survey,
      fromSurvey,
      pathId,
      sessionId,
      featureId,
      surveyId,
    },
    labels,
  });
};

export const ContainSurveyResult = observer(_ContainSurveyResult);
